/* global axios */
import ApiClient from './ApiClient';

// Sprint AGENDAR-MSG (15/07/2026): CRUD de mensagens agendadas, nested em
// conversations. O :conversation_id da URL e o display_id (armadilha #24) —
// currentChat.id ja e o display_id, entao o componente passa direto.
//
// Sprint AGENDAR-MSG.1: aceita tambem template (janela 24h da Meta).
//
// URL: /api/v1/accounts/:account_id/conversations/:display_id/bmt_scheduled_messages
class BmtScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  urlFor(conversationId) {
    return `${this.url}/${conversationId}/bmt_scheduled_messages`;
  }

  list(conversationId) {
    return axios.get(this.urlFor(conversationId));
  }

  // scheduledAt: string ISO8601 em UTC (o modal converte do fuso do operador).
  // templateName/templateParams: so no modo template (fora da janela de 24h).
  schedule(conversationId, { content, scheduledAt, templateName, templateParams }) {
    const payload = { content, scheduled_at: scheduledAt };
    if (templateName) {
      payload.template_name = templateName;
      payload.template_params = templateParams;
    }
    return axios.post(this.urlFor(conversationId), payload);
  }

  cancel(conversationId, id) {
    return axios.delete(`${this.urlFor(conversationId)}/${id}`);
  }
}

export default new BmtScheduledMessagesAPI();
